import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressComponent implements OnInit, OnDestroy {
  @Input()
  total = 100;

  @Input()
  public get value() {
    return this._value;
  }
  public set value(value) {
    this._value = value;
    this.percentWidth = (this.value / this.total) * 100;
    this.changeDetector.markForCheck();
  }
  private _value = 0;

  percentWidth = 0;
  private ngUnsubscribe = new Subject();

  constructor(private router: Router, private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    this.router.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.value = 0;
      }
    });
  }

  ngOnDestroy() {
    this.changeDetector.detach();

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
